/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateDocumentFolderResponseData,
  CreateDocumentFolderResponseDataFromJSON,
  CreateDocumentFolderResponseDataFromJSONTyped,
  CreateDocumentFolderResponseDataToJSON
} from './CreateDocumentFolderResponseData'

/**
 *
 * @export
 * @interface CreateDocumentFolderResponse
 */
export interface CreateDocumentFolderResponse {
  /**
   *
   * @type {number}
   * @memberof CreateDocumentFolderResponse
   */
  status?: number
  /**
   *
   * @type {CreateDocumentFolderResponseData}
   * @memberof CreateDocumentFolderResponse
   */
  data?: CreateDocumentFolderResponseData
}

export function CreateDocumentFolderResponseFromJSON(json: any): CreateDocumentFolderResponse {
  return CreateDocumentFolderResponseFromJSONTyped(json, false)
}

export function CreateDocumentFolderResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateDocumentFolderResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateDocumentFolderResponseDataFromJSON(json['data'])
  }
}

export function CreateDocumentFolderResponseToJSON(value?: CreateDocumentFolderResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateDocumentFolderResponseDataToJSON(value.data)
  }
}
